import React from 'react';

import { SubModuleProps, alterContainerTable } from '@utils/alterContainerTable';
import Accordions from '@sections/Accordions';
import BodyTable from '@sections/BodyTable';

import './style.css';

export type ContainerTableProps = {
  item: {
    contentful_id: string,
    title: string,
    tableContent: {
      content: string[],
    },
    textWarnings: {
      textWarnings: string,
    }
    accordionTitle: string,
    accordionContent: {
      title: string,
      description: string,
      cta: string,
      ctaHref: string,
      ctaText: string,
      ctaColor: string,
    },
    tableContentAlternative: {
      content: string[],
      group: string,
    }
  },
};

const ContainerTable = ({
  item,
}: ContainerTableProps): JSX.Element => {
  const {
    contentful_id: tid,
    title,
    textWarnings:{
      textWarnings,
    },
    accordionTitle,
    accordionContent,
    tableContentAlternative,
  } = alterContainerTable(item as unknown as SubModuleProps);

  const strToRender = textWarnings.split(/\r?\n/)
  const headerPackage = tableContentAlternative?.content?.[0]?.[0] === 'Header';

  return (
    <div className={accordionTitle === null && accordionContent === null ? 
                    "container-table--main-packages" : "container-table--main" }>
      <section className={accordionTitle === null && accordionContent === null ? 
                    "container-table__top-packages" : "container-table__top" }>
        {
          title ? 
          <>
            <h1>{title}</h1>
          </> :
          null
        }

      </section>
      <section className={accordionTitle === null && accordionContent === null ? 
                    "container-table__inner-packages" : "container-table__inner" }>
        <table>
          <BodyTable
            isHeader={tableContentAlternative?.group === 'header' || (headerPackage || title === 'RepTrak Packages')}
            rowsContent={tableContentAlternative?.content}
            tid={tid}
          />
        </table>
        {
          textWarnings === "." ? null :
          <div style={{display: "flex", flexDirection: "column", fontSize: "10px", lineHeight:"20px"}}>
            {strToRender.map((item,indx)=><span key={indx}>{item}</span>)}
          </div>
        }
      </section>
      
      {
        accordionTitle === null && accordionContent === null ? <></> :
        <section className='container-accordion'>
          <hr />
          <h2>{accordionTitle}</h2>
          <Accordions item={accordionContent} />
        </section>
      }
    </div>
  );
};

export default ContainerTable;